import React from 'react'
import { Nav, NavItem, NavLink, Collapse } from "reactstrap";


const NavTemporal = () => {
    return (
        <Nav className="nav_nologin">
        <NavItem>
            <NavLink href="http://normativainterna.espol.edu.ec/" target="_blank">
                Reglamentos
            </NavLink>
        </NavItem>
        <NavItem>
            <NavLink href="/formularios/" target="_blank">
                Formularios
            </NavLink>
        </NavItem>
        <NavItem>
            <NavLink href="https://talentohumano.espol.edu.ec/contactenos.aspx/" target="_blank">
                Contáctenos
            </NavLink>
        </NavItem>
    </Nav>
    )
}
export  default  NavTemporal;
